import React from 'react';
import { Swiper } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper';

// import "swiper/scss/free-mode";
// import "swiper/scss/navigation";
// import "swiper/scss/thumbs";

interface Props {
  children: React.ReactNode;
  setThumbsSwiper: any;
  initialSlide: number;
}

export const CommentsSliderDesktop: React.FC<Props> = ({
  children,
  setThumbsSwiper,
  initialSlide = 0,
}) => {
  return (
    <Swiper
      initialSlide={initialSlide}
      onSwiper={setThumbsSwiper}
      spaceBetween={0}
      slidesPerView={1}
      direction="horizontal"
      centeredSlides={true}
      watchSlidesProgress={true}
      modules={[Navigation]}
      noSwiping={true}
      simulateTouch={false}
      style={{ width: '100%', height: '100%' }}
      loop={true}
      allowTouchMove={false}
    >
      {children}
    </Swiper>
  );
};
